let mainPath = "/booklists";
let viewFolder = "Booklist";

module.exports = [
    {
        path: mainPath,
        name: 'booklists',
        component: () => import(/* webpackChunkName: "Booklist" */ '../views/'+viewFolder+'/Index.vue'),
    },
    {
        path: mainPath+'/view/:id',
        name: 'booklist',
        component: () => import(/* webpackChunkName: "Booklist" */ '../views/'+viewFolder+'/View.vue'),
    }
]
